/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */
/* eslint comma-dangle: 0 */
export function pushPageView(dataGroup) {
	window.dataLayer.push({
		event: 'pageView',
		ecommerce: {
			// index: CustomDimensionID is TBA,
			// dataGroup needs to be specified in BE
			// Body tag in HTML to include Visitor Groups via a custom data attribute - data-group="{VisitorGroup}"
			index: '123',
			value: dataGroup,
		},
	});
}

export function pushFormSubmit(formID) {
	window.dataLayer.push({
		event: 'formSubmit',
		ecommerce: {
			category: 'form',
			action: 'submit',
			label: formID,
			value: null
		},
		eventCallback: function() {
			// may need callback logic in the future..
			// if (url) {
			// 	window.location = url;
			// }
			// if (form) {
			// 	$(form).submit();
			// }
		}
	});
}

export function pushCarparkSearch(arrivalDate, departureDate, location) {
	if (window.dataLayer) {
		window.dataLayer.push({
			event: 'formSubmit',
			ecommerce: {
				arrivalDate,
				departureDate,
				location,
			}
		});
	}
}
// reference for GTM carpark tracking
// export function cartCheckoutButton(products, form) {
// 	// map props to what we need only
// 	let mappedProducts = products.map(function(product) {
// 		let obj = {
// 			id: product.itemSkuNumber,
// 			name: product.name,
// 			brand: product.brand,
// 			category: product.categoryName,
// 			price: (product.lineItemDiscountTotal.amount) ? product.lineItemDiscountTotal.amount || 0 : product.price.amount || 0,
// 			quantity: product.quantity || 1
// 		};
// 		if (obj.name || obj.id) return obj;
// 	});
// 	if (mappedProducts.length > 0) {
// 		window.dataLayer.push({
// 			event: 'checkout',
// 			ecommerce: {
// 				checkout: {
// 					actionField: {
// 						step: 1,
// 						option: 'Checkout'
// 					},
// 					products: mappedProducts
// 				}
// 			},
// 			eventCallback: function() {
// 				$(form).submit();
// 			}
// 		});
// 	}
// }
